module.exports = __webpack_public_path__ + "static/media/couch.d2d77367.svg";